function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 0a9 9 0 110 18A9 9 0 019 0zm0 2a7 7 0 100 14A7 7 0 009 2z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgMicro = function SvgMicro(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18,
      height: 18
    }, props), _ref)
  );
};

export default SvgMicro;